var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#06BAB2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88643 13.8337C8.72023 13.8337 8.56786 13.7824 8.44321 13.6672L5.68699 11.1183C5.43768 10.8878 5.43768 10.5291 5.68699 10.2986C5.93629 10.0681 6.32409 10.0681 6.5734 10.2986L8.90028 12.4376L14.4266 7.3399C14.6759 7.10935 15.0637 7.10935 15.313 7.3399C15.5623 7.57045 15.5623 7.92908 15.313 8.15963L9.34348 13.6672C9.20498 13.7824 9.05263 13.8337 8.88643 13.8337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.a8f67d5a243c9807c5aa09ff5e8f42f7.svg";
export { ForwardRef as ReactComponent };